import * as React from 'react';
import {Backdrop, CircularProgress} from "@mui/material";

export type LoadingBackdropProps = {
    open: boolean;
    onClick: () => void;
};

const LoadingBackdrop: React.FC<LoadingBackdropProps> = (props) => {

    return (
        <Backdrop
            sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
            open={props.open}
            onClick={() => props.onClick()}>
            <CircularProgress color="inherit"/>
        </Backdrop>
    );
}

export default LoadingBackdrop;